import {NgbTabChangeEvent,NgbTabset,NgbTabsetConfig} from '@ng-bootstrap/ng-bootstrap';
import { Component,NgZone, OnInit,ViewChild, PLATFORM_ID, Inject, Input, Output, EventEmitter, OnChanges, ElementRef,HostListener } from '@angular/core';
import { FormBuilder,FormGroup,FormControl,Validators,NgForm } from '@angular/forms';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { Router,ActivatedRoute } from '@angular/router';
import {commonService} from "../../service/common.service";
import { sessionService } from '../../service/session.service';
import { jobService } from '../../service/job.service';
import { HttpErrorResponse } from '@angular/common/http';
import { userService } from '../../service/user.service';
import {Globals } from '../../globals';


import { GooglePlaceDirective } from "ngx-google-places-autocomplete/ngx-google-places-autocomplete.directive";
import { ComponentRestrictions } from "ngx-google-places-autocomplete/objects/options/componentRestrictions";
import { Address } from "ngx-google-places-autocomplete/objects/address";
import { AutoCompleteSearchService } from 'ng4-geoautocomplete/auto-complete.service';
import { GlobalRef } from 'ng4-geoautocomplete/windowRef.service';
import { AgmCoreModule, MapsAPILoader,GoogleMapsAPIWrapper } from '@agm/core';
import { contentService } from '../../service/content.service';
import { ViewEncapsulation } from '@angular/core';


@Component({
  selector: 'app-jobannouncementlist',
  templateUrl: './jobannouncementlist.component.html',
  providers: [NgbTabsetConfig,NgbTabset,sessionService,jobService,userService,contentService],
  styleUrls: ['./jobannouncementlist.component.css']
})


export class JobannouncementlistComponent implements OnInit {
  announcementlist:Array<any>=[];
  announcementSort:Array<any>=[];
  viewMore=true
  contentlist=[];
  limit=20;
  obj:any;
  totalrow:number;
  notfound=false;
  msg:any;
  isError=false;
  
   constructor(config: NgbTabsetConfig,public tabset: NgbTabset,public router: Router,private frmBuilder: FormBuilder,private commonService:commonService,private _session:sessionService,private job:jobService,private route: ActivatedRoute,private _user:userService,private _autoCompleteSearchService: AutoCompleteSearchService,
    private ngZone: NgZone,private global: Globals,private _elmRef: ElementRef,@Inject(PLATFORM_ID) private platformId: Object,private _content:contentService) {
      this.obj={};
      this.obj['offset'] = 0;
      this.obj['limit'] = 20; 
      this.obj.announcelist=[];
    }
  ngOnInit() {

      this.getannoucelist(this.obj);    
  }


  viewmoretopic(){ // need to check data
    
      this.obj.viewmore=false; //this.isPostLoad = true;
      let objdata={};    
      objdata['offset']= this.obj.announcelist.length?this.obj.announcelist.length:0; 
      objdata['limit'] =50; 
     // console.log('data',objdata);
      this.getannoucelist(objdata);    
   }

  getannoucelist(obj){   
    this.job.getannoucelist(obj).subscribe((data : any)=>{
            if(data.error==0){
                this.announcementlist = data.results.rows; 
                //console.log('list',this.announcementlist);

              Array.prototype.push.apply(this.obj.announcelist,this.announcementlist);
              //console.log('grtrtert',this.obj.announcelist);
              if(data.results.count > this.obj.announcelist.length){
                  this.obj.viewmore=true;
              }else{
                this.obj.viewmore=false;
              }     

              this.totalrow = data.results.count;
              if(this.totalrow==0){
                this.notfound=true;
              }else{
                this.notfound=false;
              }        
            }else{  
             // console.log('No DAta');            
               this.msg = data.message;
               this.isError = true;              
            }
     },
       (error : HttpErrorResponse)=>{
         this.isError = true;
         this.msg="internal server error!";
       });          
}

announceListsort(announcementSort){ 
  this.announcementSort = announcementSort;
  this.announcementSort.reverse();
        }

}




// WEBPACK FOOTER //
// C:/projects/wct-nextias-ui/src/app/home/jobannouncementlist/jobannouncementlist.component.ts